<template>
  <div class="room-content">
    <Navbar :appTitle="appTitle" :rightShow="true" rname="scan" @changeScan="changeScan" @ClickRight="ClickRight">
    </Navbar>
    <Search
        ref="topSearch"
        class="search"
        placeholder="拣货任务编号 | 物品名称"
        :isAdd="false"
        :isScreen="true"
        :isType="true"
        @onSearch="onSearch"
        @onScreen="onScreen"
        @newBuild="newBuild"
    >
    </Search>
    <search-tag ref="SearchTag" @getCategory="getCategory"></search-tag>
    <!--分页列表 -->
    <div class="listBox">
      <pageList
          :usedGetMethods="true"
          ref="pageList"
          :checkedShow="false"
          :columns="columns"
          :minLen="3"
          :listUrl="listUrl"
          @handleList="handleList"
      >
        <div slot="foot" slot-scope="{ item }" class="operateBox">
          <div
              class="pubBtn"
              @click.stop="pickingCheck(item)"
              v-if="item.unVerificationNum > 0"
          >
            核验
          </div>
        </div>
      </pageList>
    </div>
  </div>
</template>
<script>
import Navbar from "../../../components/navBar/navBar_right_outTask";
import Search from "@/components/search";
import SearchTag from "./SearchTag";
import pageList from "@/components/pageList";
import {pickingTasksdelete} from "@/api/mobile";
import {Dialog} from "vant";

export default {
  name: "pickingTasks",
  components: {
    Navbar,
    Search,
    pageList,
    SearchTag,
  },
  data() {
    return {
      appTitle: "拣货任务",
      listUrl: "/jksaas-produce/produce/wmsPickingTask/wholeList", //拣货任务列表接口
      columns: {
        titleKey: "pickingCode", //标题
        subtitleKey: null, //副标题
        content: [
          //内容
          {
            name: "业务类型",
            key: ["typeText"],
          },
          {
            name: "物品明细",
            key: ["goodsDetails"],
          },
          {
            name: "待核验/拣货数量",
            key: ["unVerificationNum", "pickingQuantity"],
          },
        ],
      },
      keyword: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.SearchTag.showSearchTag) {
      this.appTitle = this.$route.query.navTitle;
      this.$refs.SearchTag.showSearchTag = false;
      next(false);
    } else {
      next();
    }
  },
  created() {
  },
  mounted() {
    this.searchQuery();
  },
  methods: {
    changeScan(v) {
      console.log(v, 'vvv')
      if (v.code.EntityType !== "picking") {
        this.$toast("请扫正确二维码");
      }

      this.$router.push({
        path: "/pickingTasksVerification",
        query: {
          id: v.code.id,
        },
      });
    },
    // 搜索
    searchQuery(searchObj) {
      let params = {
        operateType: 2,
        type: 1,
        ...searchObj,
      };
      this.$refs.pageList.searchQuery(params);
    },
    // 编号查询
    onSearch(v) {
      this.keyword = v;
      let searchObj = {
        entryCode: this.keyword,
      };
      if(this.keyword){
        searchObj ={
          keyword: this.keyword,
        }
      }
      this.searchQuery(searchObj);
    },
    // 更多查询页面
    onScreen() {
      this.appTitle = "更多筛选";
      this.keyword = this.$refs.topSearch.value;
      this.$refs.SearchTag.showModal(this.keyword);
    },
    getCategory(sureObj) {
      this.appTitle = "拣货任务";
      this.keyword = sureObj.keyword;
      this.$refs.topSearch.value = sureObj.keyword;
      this.searchQuery(sureObj);
    },
    // 新建
    newBuild() {
      this.$router.push({
        path: "/pickingTasksForm",
      });
    },
    // 删除
    handleDelete(e) {
      Dialog.confirm({
        title: "确定删除拣货任务吗？",
        message:
            "拣货任务删除后，库存会同步增加，出库明细会同步删除，删除后不可恢复。",
        confirmButtonColor: "#2b85e4",
      })
          .then(() => {
            pickingTasksdelete({id: e.id}).then((res) => {
              if (res.success) {
                this.$toast("拣货任务删除成功");
                this.searchQuery();
              } else {
                this.$toast(res.message);
              }
            });
          })
          .catch(() => {
          });
    },
    pickingCheck(item) {
      this.$router.push({
        path: "/pickingTasksVerification",
        query: {
          id: item.taskId,
        },
      });
    },
    // 编辑
    handleEdit(e) {
      this.$router.push({
        path: "/pickingTasksForm",
        query: {
          id: e.id,
        },
      });
    },
    // 拣货任务详情
    handleList(id, item, type) {
      if (type == "列表") {
        this.$router.push({
          path: "/pickingTasksDetail",
          query: {
            id: item.taskId,
            unVerificationNum: item.unVerificationNum,
            verificationNum: item.verificationNum,
          },
        });
      }
    },
    ClickRight() {
      this.$refs.SearchTag.showSearchTag = false;

      // this.$router.push({
      //   path: "/application",
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.flex(@jc,@ai,@fd:row) {
  display: flex;
  justify-content: @jc;
  align-items: @ai;
  flex-direction: @fd;
}

.search {
  position: fixed;
  top: 93px;
  z-index: 98;
  width: 100%;
}

.listBox {
  margin-top: 120px;
  overflow-y: hidden;
}

.room-content {
  height: 100vh;
  overflow-y: scroll;

  .serach {
    height: 0.33rem;
    background: #f2f2f6;
    border-radius: 0rem;
    margin-bottom: 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 0.33rem;
    padding: 0.1rem 0.12rem;

    .placeh {
      font-size: 0.16rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 0.23rem;
    }

    .icon {
      width: 0.15rem;
      height: 0.16rem;
    }
  }
}

.operateBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: 3px;
  font-size: 28px;
  font-weight: 500;
  color: #1890ff;
}

.pubBtn {
  margin-right: 20px;

  &:nth-last-child(1) {
    margin-right: 0;
  }
}
</style>
